import { Component, Input } from '@angular/core'

@Component({
	selector: 'app-loader-background',
	templateUrl: './loader.component.html'
})
export class LoaderBackgroundComponent {

	@Input()
	public isLoading: boolean = false

	@Input()
	public loadingText: boolean = false

	constructor(
	) {}
}
